const CHUNK_ERROR_RETRY_KEY = "chunk-load-retry-ts";
const CHUNK_ERROR_RETRY_TTL_MS = 60_000;

const getErrorMessage = (error: unknown) => {
  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === "string") {
    return error;
  }

  return "";
};

export const isChunkLoadError = (error: unknown) => {
  if (error instanceof Error && error.name === "ChunkLoadError") {
    return true;
  }

  const message = getErrorMessage(error);

  return (
    message.includes("ChunkLoadError") ||
    message.includes("Loading chunk") ||
    message.includes("Loading CSS chunk")
  );
};

export const tryRecoverChunkLoadError = (error: unknown) => {
  if (!isChunkLoadError(error) || typeof window === "undefined") {
    return false;
  }

  try {
    const lastRetryAt = Number(window.sessionStorage.getItem(CHUNK_ERROR_RETRY_KEY) ?? 0);
    const isRetryAllowed = Date.now() - lastRetryAt > CHUNK_ERROR_RETRY_TTL_MS;

    if (!isRetryAllowed) {
      return false;
    }

    window.sessionStorage.setItem(CHUNK_ERROR_RETRY_KEY, String(Date.now()));
  } catch (storageError) {
    console.error("CHUNK LOAD RETRY STORAGE ERROR", storageError);
  }

  window.location.reload();
  return true;
};
